export class SessionTitleRequest {
    UserInteraction: string;
    SessionId: string;

    constructor(userInteraction: string, sessionId: string) {
        this.UserInteraction = userInteraction;
        this.SessionId = sessionId;
    }
}